import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance, { setBaseURL } from '../api/axios';
import { BASE_URL } from '../constants/apiConstants';
import { UserData, UserState } from '../types/userTypes';

export interface GetUserDetailsResult {
  userData: UserData;
  mainSite: any | null;
}

export const getUserDetails = createAsyncThunk<GetUserDetailsResult, string>(
  'user/getUserDetails',
  async (userId: string | null) => {
    try {
      setBaseURL(`${BASE_URL}/api/v1/User`);
      const payload = {
        userid: userId
      }
      const response = await axiosInstance.post<UserData>(`/GetUserDetailsDataByUserID`, payload);     

      // Defensive extraction of usertype. Some API responses use lowercase keys (userdetails),
      // while our TypeScript types expect camelCase (userDetails). Cast to any and check both.
      const respData: any = response.data as any;
      const usertype = (respData && (respData.data?.userdetails?.usertype || respData.data?.userDetails?.usertype)) || '';

      let mainSite: any | null = null;
      if (typeof usertype === 'string' && usertype.trim() === 'Non CPU') {
        // Call extra endpoint only for Non CPU users and capture the response
        try {
          const mainSiteResp = await axiosInstance.post<any>(`/GetUserMainSiteCode`, payload);
          mainSite = mainSiteResp?.data ?? null;
        } catch (err) {
          console.warn('GetUserMainSiteCode failed', err);
          mainSite = null;
        }
      }
      
    

  return { userData: response.data, mainSite };
    } catch (error: any) {
      throw error;
    }
  }
);

const initialState: UserState = {
  loading: false,
  data: null,
  mainSite: null,
  error: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUserDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUserDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.userData;
        state.mainSite = action.payload.mainSite ?? null;
      })
      .addCase(getUserDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || null;
      });
  },
});

export default userSlice.reducer;
